import {Component, Input, NgZone, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationService} from '../../services/notification.service';

@Component({
  selector: 'app-guest-alert',
  templateUrl: './guest-alert.component.html',
  styleUrls: ['./guest-alert.component.scss']
})
export class GuestAlertComponent implements OnInit {

  @Input('data') data;
  public notifySound = true;

  constructor(
    public activeModal: NgbActiveModal,
    private notificationService: NotificationService,
    private ngZone: NgZone
  ) { }

  ngOnInit() {
    this.ngZone.runOutsideAngular(() => {
      this.notificationService.audio.loop = true;
      this.notificationService.audio.play();
    });
  }

  toggleSound() {
    this.notifySound = !this.notifySound;
    if (!this.notifySound) {
      this.notificationService.audio.pause();
    } else { this.notificationService.audio.play(); }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/guest-alert/guest-alert.component.ts